export const VALIDATION_CONFIG = {
  defaultMaxFileSize: 4194304, // 4MiB = 4 * 1024 * 1024 bytes
  profilePictureMimetypes: ['image/jpeg', 'image/png', 'image/svg+xml'],
  documentMimetypes: [
    'image/jpeg',
    'image/png',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'text/plain',
  ],
  instituteLogoMimetypes: ['image/jpeg', 'image/png', 'image/svg+xml'],
  adMimeTypes: ['image/jpeg', 'image/png', 'image/svg+xml'],
};
